import styled from "styled-components"

const NavigationIcon = styled.div`
  display: flex;
  flex-grow: 0;
  align-items: center;
  position: relative;
  margin-left: auto;

  & > * {
    margin: auto;
  }
`

export default NavigationIcon



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationIcon.js